module.exports = __webpack_public_path__ + "35604b59b29be04ddfa29edb8e6edbcb.png";